import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';

import { RdsNumberPipeModule } from '../core/pipes';
import { RdsGetTableDimDatumCellIdsPipe } from './get-datum-cell-ids.pipe';
import { RdsGetDatumValuePipe } from './get-datum-value.pipe';
import { RdsGetHeaderCellValuePipe } from './get-header-cell-value.pipe';
import { RdsIncludeSubtotalsPipe } from './include-subtotals.pipe';
import { RdsPercentOfTotalPipe } from './percent-of-total.pipe';
import { RdsTabulationTableComponent } from './tabulation-table.component';
import { RdsGetVariableCellValuePipe } from './get-variable-cell-value.pipe';

const PIPES = [
  RdsGetHeaderCellValuePipe,
  RdsIncludeSubtotalsPipe,
  RdsGetDatumValuePipe,
  RdsGetTableDimDatumCellIdsPipe,
  RdsGetVariableCellValuePipe,
  RdsPercentOfTotalPipe,
];

@NgModule({
  imports: [CommonModule, FlexLayoutModule, MatIconModule, MatTableModule, RdsNumberPipeModule],
  exports: [RdsTabulationTableComponent],
  declarations: [RdsTabulationTableComponent, PIPES],
  providers: [RdsGetDatumValuePipe],
})
export class RdsTabulationTableModule {}

export * from './models/index';
export * from './tabulation-table.component';
